import { useState } from 'react'

import { getRouteApi } from '@tanstack/react-router'
import { Button, IconButton } from 'ui/components/Buttons'
import { DateTime } from 'ui/components/DateTime'
import { Hr } from 'ui/components/Hr'
import { IconName } from 'ui/components/Icon'
import { InfoSetDirection } from 'ui/components/Info'
import { Col, Row } from 'ui/themes/globalStyles'
import { AdverseMediaDetailsType } from '~bank-adverse-media/types/details'

import { NumBadge } from '../../../../components/NumBadge'
import { RiskLevel } from '../../../../components/RiskLevel'
import { EditNotesDialog, HistoryDialog, RelatedEntitiesDialog } from './components'

import { s } from './styles'

export const GeneralInformation = () => {
  const routeApi = getRouteApi('/_app/adverse-media/$id')
  const loaderData = routeApi.useLoaderData({ select: (s) => s }) as AdverseMediaDetailsType
  const [isHistoryDialogOpened, setIsHistoryDialogOpened] = useState(false)
  const [isEditNotesDialogOpened, setIsEditNotesDialogOpened] = useState<boolean>(false)
  const [isRelatedEntitiesListDialogOpened, setIsRelatedEntitiesListDialogOpened] = useState<boolean>(false)

  const showEditNotesDialog = () => setIsEditNotesDialogOpened(true)
  const closeEditNotesDialog = () => setIsEditNotesDialogOpened(false)

  const showRelatedEntities = () => setIsRelatedEntitiesListDialogOpened(true)
  const closeRelatedEntities = () => setIsRelatedEntitiesListDialogOpened(false)

  const showHistoryDialog = () => setIsHistoryDialogOpened(true)
  const closeHistoryDialog = () => setIsHistoryDialogOpened(false)

  return (
    <div id="adverse-general-information">
      {isEditNotesDialogOpened && <EditNotesDialog onClose={closeEditNotesDialog} />}
      {isHistoryDialogOpened && <HistoryDialog onClose={closeHistoryDialog} />}
      {isRelatedEntitiesListDialogOpened && <RelatedEntitiesDialog onClose={closeRelatedEntities} />}
      <Hr />
      <s.MediaInfoSet direction={InfoSetDirection.COLUMN}>
        <Row>
          <Col>
            <s.MediaInfo label="Needs Review">
              {loaderData.alertedPublicationsCount ? <NumBadge>{loaderData.alertedPublicationsCount}</NumBadge> : '--'}
            </s.MediaInfo>
          </Col>
        </Row>
        <Row>
          <Col>
            <s.MediaInfo label="Risk Level">
              <RiskLevel riskLevel={loaderData.riskLevel} />{' '}
              {loaderData.riskLevelSetAt && (
                <>
                  (updated on <DateTime date={loaderData.riskLevelSetAt} />)
                </>
              )}
            </s.MediaInfo>
          </Col>
          <Col>
            {loaderData.previousRiskLevel && (
              <s.MediaInfo label="Previous Risk Level">
                <RiskLevel riskLevel={loaderData.previousRiskLevel} />{' '}
                {loaderData.previousRiskLevelSetAt && (
                  <>
                    (updated on <DateTime date={loaderData.previousRiskLevelSetAt} />)
                  </>
                )}
              </s.MediaInfo>
            )}
          </Col>
        </Row>
        <s.NotesWrapper>
          <s.NotesInfo label="Notes">{loaderData.notes || '-'}</s.NotesInfo>
          <Button face="secondary" onClick={showEditNotesDialog}>
            Edit Notes
          </Button>
        </s.NotesWrapper>
        <Row>
          <Col>
            <s.MediaInfo label="Last Scan Date">
              <DateTime date={loaderData?.lastScanDate} withTime />
            </s.MediaInfo>
          </Col>
          <Col>
            <s.MediaInfo label="Last Modified Date">
              <DateTime date={loaderData?.lastModifiedDate} withTime />
            </s.MediaInfo>
          </Col>
        </Row>
        <Row>
          <Col>
            <IconButton face="positive" icon={IconName.GROUP} onClick={showRelatedEntities}>
              Show Related Entities
            </IconButton>
          </Col>
        </Row>
        <Row>
          <Col>
            <IconButton face="positive" icon={IconName.HISTORY} onClick={showHistoryDialog}>
              Show History
            </IconButton>
          </Col>
        </Row>
      </s.MediaInfoSet>
    </div>
  )
}
